import { useTranslation } from "@hireroo/i18n";
import Box from "@mui/material/Box";
import { type ButtonProps } from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";

const Wrapper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  minWidth: 296,
  width: "100%",
}));

const TextWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  height: 36,
}));

const HeaderWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
}));

const Body = styled(Typography)(() => ({
  fontSize: 16,
}));

const TrialLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 14,
  fontWeight: 400,
}));

export type ContractProps = {
  editButton: Pick<ButtonProps, "disabled">;
  contractPeriodLabel:
    | {
        kind: "TEXT";
        value: string;
      }
    | {
        kind: "TRIAL";
      };
};

const Contract: React.FC<ContractProps> = props => {
  const { t } = useTranslation();

  return (
    <Wrapper elevation={4}>
      <HeaderWrapper mb={1.5}>
        <TextWrapper>
          <Typography variant="subtitle2" color="text.secondary">
            {t("契約期間")}
          </Typography>
        </TextWrapper>
      </HeaderWrapper>
      <Box>
        {props.contractPeriodLabel.kind === "TEXT" && <Body variant="subtitle2">{props.contractPeriodLabel.value}</Body>}
        {props.contractPeriodLabel.kind === "TRIAL" && <TrialLabel variant="subtitle2">{t("無料トライアル期間中")}</TrialLabel>}
      </Box>
    </Wrapper>
  );
};

Contract.displayName = "Contract";

export default Contract;
